<script>
    import UserAddHeader from '@/components/page-user-edit/user-add/UserAddHeader.vue';
    import UserAddData from '@/components/page-user-edit/user-add/UserAddData.vue';

    export default {
        components: {
            UserAddData: UserAddData,
            UserAddHeader: UserAddHeader,
        },
        computed: {
            isShowUserAdd() {return this.$store.getters.IS_SHOW_UDER_ADD},
        }
    }
</script>


<template>
    <div
        class="left_additional_container"
        v-if="isShowUserAdd"
    >
        <UserAddHeader />
        <hr class="hr_light_98">
        <UserAddData />
    </div>
</template>